import it from '../locale/it.json';
import en from '../locale/en.json';
const translations = { it, en };

export default {
  install(Vue) {
    Vue.prototype.$locale = translations[process.env.VUE_APP_LANG || 'it'];
  }
};
